// extracted by mini-css-extract-plugin
export default {"button":"RightButtons_button__rO2q6","buttonQuestion":"RightButtons_buttonQuestion__4cF1t","languageButton":"RightButtons_languageButton__D0Onk"};